import axios from 'axios'

// state
export const state = {
  isEmailValidationVisible: false,
}

// getters
export const getters = {
}
// mutations
export const mutations = {
  setEmailValidationModalVisibility(state, { isVisible }) {
    state.isEmailValidationVisible = isVisible
  },

}
// actions
export const actions = {
  openEmailValidationModal({ commit }) {
    commit('setEmailValidationModalVisibility', { isVisible: true })
  },
  closeEmailValidationModal({ commit }) {
    commit('setEmailValidationModalVisibility', { isVisible: false })
  },
  async postResendEmailValidation() {
    try {
      return await axios.post(`profile/resendConfirmationEmail`)
    } catch (e) {
      return e
    }
  },
  async postValidateEmail({ commit }, { hash }) {
    try {
      return await axios.post(`profile/confirmEmailAddress`, {
        hash,
      })
    } catch (e) {
      return e
    }
  },
}
